import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { fetchOngoingApplications, fetchUpgradeApplicationSuccess } from '../../actions';
import Message from '../../components/Messages/Message';
import { AppState } from '../../reducers';

const LoanEuroTaxSuccess = (): JSX.Element => {
    const dispatch = useDispatch<any>();
    const { appId } = useParams<'appId'>();

    useEffect(() => {
        return () => {
            dispatch(fetchOngoingApplications());
            dispatch(fetchUpgradeApplicationSuccess());
        };
    }, [dispatch]);

    const { context, feature } = useSelector((state: AppState) => state);
    const { data } = context.config;
    const { text } = data;
    const { landingPageTitle, landingPageNoOngoingApplications } = text;
    const { salgspantActivateLoanFromLc } = feature;

    if (!salgspantActivateLoanFromLc || !appId) {
        return (
            <div className="ongoing-applications ongoing-applications--none">
                <div style={{ maxWidth: '500px', margin: '0 auto' }}>
                    <>
                        <h1>{landingPageTitle}</h1>
                        <p>{landingPageNoOngoingApplications}</p>
                    </>
                </div>
            </div>
        );
    }

    return (
        <>
            <Message
                title={text.loanUpgradeSuccessTitle}
                text={[
                    text.loanUpgradeSuccessText1 + appId,
                    text.loanUpgradeSuccessText2,
                    text.loanUpgradeSuccessText3,
                ]}
                link={text.loanUpgradeSuccessLink}
                linkText={text.loanUpgradeSuccessLinkText}
                infoBox={text.loanUpgradeSuccessInfoBox}
                image="Heart"
            />
        </>
    );
};
export default LoanEuroTaxSuccess;
